module.exports = __webpack_public_path__ + "img/filter_2.c898b167.svg";